export const getCurrentBanner = (
  campaign,
  secondCampaign,
  currentBannerList,
  setCurrentBanner,
  setBannerIndex,
  campaignConfigurations,
  getSpecificBannerIndex,
  getRandomBannerIndex
) => {
  const hasCampaignBanner =
    campaign && campaignConfigurations(process.env.REACT_APP_CAMPAIGN).banner

  const hasSecondCampaignBanner =
    secondCampaign &&
    campaignConfigurations(process.env.REACT_APP_SECOND_CAMPAIGN).banner

  if (hasCampaignBanner) {
    setCurrentBanner(currentBannerList, true, process.env.REACT_APP_CAMPAIGN)
  }

  if (hasSecondCampaignBanner) {
    setCurrentBanner(
      currentBannerList,
      true,
      process.env.REACT_APP_SECOND_CAMPAIGN
    )
  }

  if (hasCampaignBanner || hasSecondCampaignBanner) {
    return setBannerIndex(
      getSpecificBannerIndex(currentBannerList[currentBannerList.length - 1])
    )
  }

  return setBannerIndex(getRandomBannerIndex())
}
